var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-btn',{attrs:{"flat":"","dense":"","size":"0.7em","icon":"mdi-eye-outline"},on:{"click":_vm.handlerView}},[_c('q-tooltip',[_vm._v("Clique aqui para visualizar o orgão emissor e suas ações")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }